module.exports = {
    commons: {
        client: {
            singular: 'Paciente',
            plural: 'Pacientes',
        },
        specialist: {
            singular: 'Especialista',
            plural: 'Especialistas',
        }
    }
}